var _circle, _path, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmazingemoj(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16,
    r: 13,
    stroke: "#33363F",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3272 17.8333C13.649 18.3907 14.1119 18.8536 14.6693 19.1754C15.2267 19.4972 15.859 19.6666 16.5026 19.6666C17.1462 19.6666 17.7785 19.4972 18.3359 19.1754C18.8933 18.8536 19.3562 18.3907 19.678 17.8333",
    stroke: "#33363F",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.71094,
    y: 10.5417,
    width: 4.25,
    height: 2.91667,
    rx: 1.45833,
    fill: "#33363F",
    stroke: "#33363F",
    strokeWidth: 0.25,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19.0391,
    y: 10.5417,
    width: 4.25,
    height: 2.91667,
    rx: 1.45833,
    fill: "#33363F",
    stroke: "#33363F",
    strokeWidth: 0.25,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmazingemoj);
export default __webpack_public_path__ + "static/media/amazingemoj.3decc8134aecc6c63d2a0c2a235c085c.svg";
export { ForwardRef as ReactComponent };